import { exportUserAccountData as exportUserAccountDataAPI,
     checkUserAccountExportStatus as checkUserAccountExportStatusAPI, downloadUserAccountExport as downloadUserAccountExportAPI } from '../api/account-export.api'

export const exportUserAccountData = (data) => {
    return (dispatch, getState) => {
        return exportUserAccountDataAPI(data)
    }
}

export const checkUserAccountExportStatus = (data) => {
    return (dispatch, getState) => {
        return checkUserAccountExportStatusAPI(data)
    }
}

export const downloadUserAccountExport = (data) => {
    return (dispatch, getState) => {
        return downloadUserAccountExportAPI(data)
    }
}

